"use client";

import dynamic from "next/dynamic";

const Carousel = dynamic(() => import("./GalleryCarousel"), {
  loading: () => <div className="h-[50vh] bg-gray-100 animate-pulse" />,
});

interface GalleryCarouselProps {
  className?: string;
}

export default function GalleryCarouselClient(props: GalleryCarouselProps) {
  return <Carousel {...props} />;
}
